import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationsEn from './assets/i18n/en.json';
import translationsFr from './assets/i18n/fr.json';
// import translationsAe from './assets/i18n/ae.json';
const resources = {
  en: {
    translation: translationsEn
  },
  fr: {
    translation: translationsFr
  }
  ,
  // ae: {
  //   translation: translationsAe
  // }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,
    lng: 'fr',
    // interpolation: {
    //   escapeValue: false // not needed for react as it escapes by default
    // }
  });

export default i18n;